module.exports = __webpack_public_path__ + "media/stylesheets/resident/images/dummy-evt1-a2e0247f703b4dd67b34fd854277b353.jpg";